import { render, staticRenderFns } from "./AquacultureContent.vue?vue&type=template&id=d0f58eae&scoped=true"
import script from "./AquacultureContent.vue?vue&type=script&lang=js"
export * from "./AquacultureContent.vue?vue&type=script&lang=js"
import style0 from "./AquacultureContent.vue?vue&type=style&index=0&id=d0f58eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f58eae",
  null
  
)

export default component.exports